import React from 'react';
import stylesPlain from './plain.module.css';

import Field from './Field';

import { getDefinedItem } from '../../util/tools';
import { IET_SET_VALUE } from '../../util/realm/instance';

class FieldCheckBox extends Field {

	/*
		styles
			divMain
			checkbox
			label
	*/
	constructor(props) {
		super(props);
		this.state.inputValue = false;
		if( this.field && this.field.value )
			this.state.inputValue = this.field.value != 0;
	}

	handleInstanceChange = async (event) => {
		if( event.eventType == IET_SET_VALUE && event.field == this.field) {
			this.setState({ inputValue: event.newValue != 0, });
		}
	}
	handleValueChange = e => {
		let value = e.target.checked ? 1 : 0 ;
		this.props.instance.setFieldValue( this.field, value )
	}

	render() {
		if( this.field == null ) {
			return this.createDivUnknownField();
		}
		let divMainStyle = Object.assign({display: 'flex', alignItems: 'center'}, 
				getDefinedItem(this.props, ['styles', 'divMain']));
		let checkboxStyle = Object.assign({marginRight: '5px'}, 
				getDefinedItem(this.props, ['styles', 'checkbox']));
		let readOnly = this.state.readOnly;
		
		return (
			<div style={divMainStyle} >
				<input type="checkbox" onChange={this.handleValueChange} checked={this.state.inputValue} disabled={readOnly} 
					style={checkboxStyle}
				/>
				{this.createLabel()}
			</div>
		);
	}
}

export default FieldCheckBox;
